'use client';

import { useMemo } from 'react';
import { useGlobalContext } from '@/store/contexts/global-context';
import type { LauncherUrlResolutionContext } from '@/utils/url/launcher-url';

/** Values for `getLauncherUrl` / `resolveClgUrl` on the client (same-domain launch is mobile web + Amplitude only). */
export const useLauncherUrlResolution = (): LauncherUrlResolutionContext => {
    const { experiments, isAndroidWrapper, isIosWrapper, isDesktop } = useGlobalContext();
    return useMemo(
        () => ({ experiments, isAndroidWrapper, isIosWrapper, isDesktop }),
        [experiments, isAndroidWrapper, isIosWrapper, isDesktop]
    );
};
